export default __webpack_public_path__ + "static/media/Subtract (2).62b91a55.svg";